export const blockIconsCommunicationLinkOffNew = (
	<span className='material-symbols-outlined'>link_off</span>
);
